exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".al-parent {\n  position: relative !important;\n}\n.al-parent.al-overflow-hidden {\n  overflow: hidden;\n}", ""]);

// exports
